<!--
 * @Descripttion: 
 * @version: 
 * @Author: renqiang_hu
 * @Date: 2022-11-14 17:28:58
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-03-07 10:39:35
 * @FilePath: \common_web\src\views\wel\index.vue
-->
<template>
    <div class="wel">

            <!-- <span class="iconfont icon-duichengxingsheji"> &#xe603;</span> -->
        <div class="wel_img">
            <img src="~@/assets/bg.png"/>
        </div>
        <div class="wel_view">{{$t('welIndex.welSystem')}}</div>
    </div>
</template>
<script>
export default {
    data(){
        return{
            arr:[
                {name:1,val:1,dis:false},
                {name:2,val:0,dis:false},
                {name:3,val:0,dis:false},
            ]
        }
    },
    mounted(){
       
        this.test()
    },

    methods:{
        test(){
           
        }
    }
}
</script>
<style lang="scss">
.wel{
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    &_img{
        width: 650px;
        height: 504px;
        img{
            width: 100%;
            height: 100%;
        }
    }
    &_view{
        text-align: center;
        margin-top: 40px;
        font-size: 40px;
        color: #272727;
    }
}
</style>